<template>
  <div>
    <div class="l-container">
      <p></p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  methods: {
    getContracts () {
      this.$store.dispatch('getContracts')
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getContracts()
    })
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Contracts.vue?929f5fe8